import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { Controller, type Control, type FieldPath, type FieldValues } from 'react-hook-form';

export type FormTextFieldProps<T extends FieldValues> = Omit<TextFieldProps, 'name' | 'value' | 'onChange' | 'error'> & {
  name: FieldPath<T>;
  control: Control<T>;
};

/** A text field wired to react-hook-form: shows the field's error under it. */
export function FormTextField<T extends FieldValues>({ name, control, helperText, ...rest }: FormTextFieldProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          {...rest}
          name={field.name}
          disabled={rest.disabled ?? field.disabled}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={(e) => {
            rest.onBlur?.(e);
            field.onBlur();
          }}
          inputRef={field.ref}
          error={!!fieldState.error}
          helperText={fieldState.error?.message ?? helperText}
          fullWidth={rest.fullWidth ?? true}
        />
      )}
    />
  );
}
